export default function SearchInput({ value, onChange }) {
  return (
    <div className="d-flex justify-content-end">
      <div style={{ width: "100%", maxWidth: "300px" }}>
        <div
          className="d-flex border rounded overflow-hidden"
          style={{ height: "38px" }}
        >
          <input
            type="text"
            className="form-control border-0 shadow-none"
            placeholder="Search..."
            value={value}
            onChange={onChange}
            style={{ flex: 1 }}
          />
          <span className="d-flex align-items-center px-3 border-start bg-white">
            <i className="fa-solid fa-search text-muted"></i>
          </span>
        </div>
      </div>
    </div>
  );
}
